import { render } from "./VolunteerInvitationAdminCard.vue?vue&type=template&id=933d5578&scoped=true"
import script from "./VolunteerInvitationAdminCard.vue?vue&type=script&lang=js"
export * from "./VolunteerInvitationAdminCard.vue?vue&type=script&lang=js"

import "./VolunteerInvitationAdminCard.vue?vue&type=style&index=0&id=933d5578&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-933d5578"]])

export default __exports__